// How the console reaches the api (decision BD-27). The console is served from console.{domain}
// and calls api.{domain} with credentials: both are the same site, so the api's SameSite=Lax,
// HttpOnly session cookie is sent, and the api's CORS allow-list lets this origin read answers.
// In development (vite on localhost) set VITE_API_URL, for example http://localhost:8080.

export function apiBase(loc: Pick<Location, "protocol" | "hostname"> = window.location): string {
  const fromEnv = import.meta.env?.VITE_API_URL as string | undefined;
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  return `${loc.protocol}//${loc.hostname.replace(/^console\./, "api.")}`;
}

export interface ApiErrorBody {
  code: string;
  message: string;
  rule: string;
  fields: Record<string, string>;
}

export type ApiResult<T> = { ok: true; status: number; data: T } | { ok: false; status: number; error?: ApiErrorBody };

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<ApiResult<T>> {
  let res: Response;
  try {
    res = await fetch(`${apiBase()}${path}`, {
      method: init.method ?? "GET",
      credentials: "include",
      headers: init.body === undefined ? {} : { "Content-Type": "application/json" },
      body: init.body === undefined ? undefined : JSON.stringify(init.body),
    });
  } catch {
    return { ok: false, status: 0 };
  }
  const json = res.status === 204 ? undefined : await res.json().catch(() => undefined);
  if (res.ok) return { ok: true, status: res.status, data: json as T };
  return { ok: false, status: res.status, error: (json as { error?: ApiErrorBody } | undefined)?.error };
}

export interface ZdSession {
  kind: "zd";
  zdUserId: string;
  role: "support" | "super_admin";
  name?: string;
  expiresAt?: string;
}
